export default function CommentSection({ count }: { count: number }) {
  return (
    <section className="mt-10 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="mb-4 flex items-center gap-2">
        <span className="h-5 w-1.5 rounded-full bg-accent-500" />
        <h2 className="font-heading text-lg font-bold text-foreground-950">评论（{count}）</h2>
      </div>

      <div className="mb-5 flex items-start gap-2 rounded-md border border-accent-200 bg-accent-50 px-4 py-3 text-sm text-accent-800">
        <span className="mt-0.5 flex h-4 w-4 items-center justify-center">
          <i className="ri-information-line" />
        </span>
        评论功能开发中，暂不支持真实交互，敬请期待。
      </div>

      <div className="rounded-lg border border-background-200 bg-background-100 p-4">
        <textarea
          rows={3}
          disabled
          placeholder="发表评论需要登录，评论功能开发中…"
          className="w-full resize-none rounded-md border border-background-200 bg-background-50 p-3 text-sm text-foreground-600 outline-none disabled:cursor-not-allowed"
          maxLength={500}
        />
        <div className="mt-3 flex flex-wrap items-center justify-between gap-3">
          <span className="text-xs text-foreground-400">暂未接入账号体系，登录后可参与讨论</span>
          <button
            type="button"
            disabled
            className="cursor-not-allowed rounded-md bg-background-300 px-5 py-2 text-sm font-medium text-foreground-400"
          >
            提交评论
          </button>
        </div>
      </div>
    </section>
  );
}